export default {
  LOAD_SERVICE_ORDER(state, service_order) {
    state.items = service_order;
  }
};
